import React from 'react';
import { StyleSheet, Text, View, Image, Linking, TouchableOpacity } from 'react-native';
import { store } from '../../store/store';

import { ScreenRoute } from '../constants/ScreenRouteConstant';
import { addFontFamilylato, getImagePath } from '../../utils/services/CommonUtils';

import AppTheme from '../../AppTheme';
import AppStyles from '../../AppStyles';
import TextStyle from '../../TextStyle';
import regexifyString from "regexify-string";

import * as FAQs from "../constants/FAQs";

export default class FaqsComponent extends React.Component {

    state: any = {
        FAQs: [],
        faqOpenedIndex: -1,
        faqCatOpenedIndex: -1
    }
    props: any;
    constructor(props) {
        super(props);
        this.props = props;
    }

    componentDidMount() {
        this.setState({ FAQs: FAQs[this.props.faqsPage] })
    }

    previewMessageImage = (imageUrl) => {
        var imageUrlList = [{ imageUrl: imageUrl }]
        this.props.navigation.navigate(ScreenRoute.images_preview,
            { imageList: imageUrlList })
    }

    redirectTo(item) {
        switch (item.linkType) {
            case 'pageRedirect': {
                const reduxState = store.getState()
                if (item.redirectPage == ScreenRoute.search_locality) {
                    this.props.navigation.navigate(ScreenRoute.search_locality)
                } else if (item.redirectPage == ScreenRoute.acs_plans) {
                    if (reduxState.familydetails && reduxState.familydetails['familyMembers']) {
                        this.props.navigation.navigate(item.redirectPage)
                    } else this.props.navigation.navigate(item.redirectPage)
                } else {
                    this.props.navigation.navigate(item.redirectPage)
                }
            }
                break;

            case 'linkRedirect': {
                Linking.openURL(item.link)
            }
                break;

            case 'imageRedirect': {
                // disableScroll.on();
                this.previewMessageImage(getImagePath(item.rediectImageUrl))
            }
                break;

        }


    }

    updateFAQCatActive = (faqCat, index) => {
        if (this.state.faqCatOpenedIndex != -1) {
            this.setState({ faqOpenedIndex: -1 })
            if (this.state.faqCatOpenedIndex == index) {
                faqCat.active = !faqCat.active
                // this.state.FAQs[index] = faq
                this.setState({ faqCatOpenedIndex: index })
            } else {
                let lastOpenedFAQCat = this.state.FAQs[this.state.faqCatOpenedIndex]
                lastOpenedFAQCat['active'] = false
                this.state.FAQs[this.state.faqCatOpenedIndex] = lastOpenedFAQCat
                faqCat.active = true
                // this.state.FAQs[index] = faq
                this.setState({ faqCatOpenedIndex: index })
            }
        } else {
            faqCat.active = true
            // this.state.FAQs[index] = faq
            this.setState({ faqCatOpenedIndex: index })
        }
        // faq.active = !this.state.faqOpened
        // this.state.FAQs[index] = faq
        // let aayuFaq = Object.assign(this.state.FAQs, !this.state.FAQs[index].active)
        // this.setState({ faqOpenedIndex: index, faqOpened: !this.state.faqOpened })
    }

    updateFAQActive = (faqList, faq, index) => {
        if (this.state.faqOpenedIndex != -1) {
            if (this.state.faqOpenedIndex == index) {
                faq.active = !faq.active;
                // this.state.FAQs[index] = faq
                this.setState({ faqOpenedIndex: index })
            } else {
                let lastOpenedFAQ = faqList[this.state.faqOpenedIndex]
                lastOpenedFAQ['active'] = false;
                faqList[this.state.faqOpenedIndex] = lastOpenedFAQ
                faq.active = true
                // this.state.FAQs[index] = faq
                this.setState({ faqOpenedIndex: index })
            }
        } else {
            faq.active = true
            // this.state.FAQs[index] = faq
            this.setState({ faqOpenedIndex: index })
        }
        // faq.active = !this.state.faqOpened
        // this.state.FAQs[index] = faq
        // let aayuFaq = Object.assign(this.state.FAQs, !this.state.FAQs[index].active)
        // this.setState({ faqOpenedIndex: index, faqOpened: !this.state.faqOpened })
    }

    render() {
        function getBoldString(string) {
            return regexifyString({
                pattern: RegExp('Aayu app'),
                decorator: (match, index) => {
                    console.log(match);
                    return (
                        <Text
                            style={[styles.font, { fontWeight: '700' }]}
                        >
                            {match}
                        </Text>
                    );
                },
                input: string,
            });
        }

        return (
            <View style={{ backgroundColor: AppTheme.color.background, paddingHorizontal: 16, }}>

                <View style={{ marginTop: 24, marginBottom: 8 }}>
                    <Text style={TextStyle.text16xb}>
                        Frequently Asked Questions
                    </Text>
                </View>

                {this.state.FAQs.map((faqCat: any, index) => {
                    return (
                        <View key={index}>
                            {faqCat.hideHeader ? null :
                                <TouchableOpacity activeOpacity={1.0}
                                    style={[AppStyles.flexRow, AppStyles.lightShadow,
                                    {
                                        alignItems: "flex-start",
                                        marginVertical: 8, paddingHorizontal: 8, paddingVertical: 10, borderRadius: 12, backgroundColor: 'white'
                                    }]}
                                    onPress={() => {
                                        this.updateFAQCatActive(faqCat, index)
                                    }}>
                                    <View style={{ width: AppTheme.appWidth - 72, marginRight: 12 }}>
                                        <Text style={[TextStyle.text14b,
                                        { flexWrap: 'wrap' }]} >
                                            {faqCat.catName}</Text>
                                    </View>
                                    <Image source={{
                                        uri: getImagePath(
                                            '/images/oms/dark-chevron-down.svg'),
                                        width: 12, height: 8
                                    }}
                                        style={{ marginTop: 2.5 }} />
                                </TouchableOpacity>
                            }

                            {faqCat.active && <View>
                                {faqCat.quesList.map((faq, index) => {
                                    return (<View key={index} style={[AppStyles.lightShadow, { marginVertical: 4, paddingHorizontal: 8, paddingVertical: 10, borderRadius: 12, backgroundColor: 'white' }]}>
                                        <TouchableOpacity activeOpacity={1.0} style={[AppStyles.flexRow, { alignItems: "flex-start" }]}
                                            onPress={() => { this.updateFAQActive(faqCat.quesList, faq, index) }}>

                                            <View style={{ width: AppTheme.appWidth - 72, flexWrap: 'wrap', marginRight: 12 }}>
                                                <Text style={[TextStyle.text14b, {}]} >
                                                    {faq.title}</Text></View>
                                            <View style={{
                                                transform: faq.active ?
                                                    [{ rotate: '45deg' }] : [{ rotate: '0deg' }]
                                            }}><Image source={{ uri: getImagePath('/images/icons/add.svg'), width: 12, height: 12 }}
                                                style={{ marginTop: 2.5 }} />   </View>


                                        </TouchableOpacity>

                                        {faq.active && <View style={{ paddingTop: 16, paddingRight: 10 }}>
                                            {faq?.aayuPriceHead && <Text style={[AppStyles.applyFont, { fontWeight: 700 }]}>{faq.aayuPriceHead}</Text>}

                                            {faq.boldDesc ? <View>
                                                {faq.boldDesc.map((desc, i) => { return (<Text><b>{desc?.bText}</b>{desc.nText}</Text>) })}
                                            </View> : <Text style={[TextStyle.text14]}>{getBoldString(faq.description)}</Text>}

                                            {faq.subDescription && <Text style={AppStyles.applyFont}>{getBoldString(faq.subDescription)}</Text>}
                                            {faq?.boldText && <Text style={{ paddingTop: 8 }}><b>{faq?.boldText}</b></Text>}
                                            {faq.link && <Text style={styles.link} onPress={() => this.redirectTo(faq)}> {faq.link} </Text>}

                                        </View>}
                                    </View>)
                                })}
                            </View>}
                        </View>)
                })}

            </View>
        );
    }
}

const styles = StyleSheet.create(addFontFamilylato({
    modalContainer: {
        padding: 16,
        width: AppTheme.appWidth - 32,
        backgroundColor: AppTheme.color.white,
        borderRadius: 4,
        zIndex: 2000
    },
    link: {
        textDecorationLine: 'underline',
        paddingTop: 8,
        color: AppTheme.color.blue.cta
    },
    name: {
        // fontSize: 18,
        fontWeight: '600'
    },
    container: {
        flex: 1,
        // backgroundColor: '#fff',
        // alignItems: 'center',
        // justifyContent: 'center',

    },
    faqs: {
        width: '100%',
        backgroundColor: '#ffffff'
    },
    faqsHead: {
        flex: 1,
        justifyContent: 'space-between',
        flexDirection: 'row',
        padding: 16
    }
}));